import { render } from "./information-box.vue?vue&type=template&id=5b97f9c6&scoped=true"
import script from "./information-box.vue?vue&type=script&lang=js"
export * from "./information-box.vue?vue&type=script&lang=js"

import "./information-box.vue?vue&type=style&index=0&id=5b97f9c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b97f9c6"]])

export default __exports__